// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__5AoPM","wrap__textContainer":"styles_wrap__textContainer__egRkI","wrap__logo":"styles_wrap__logo__M6g7E","wrap__text":"styles_wrap__text__kUL70"};